import { BarChart, PieChart } from "@trinity/chat";

export function getGroupedPieChartData(data: PieChart['data'], groupBy: number) {
  if (groupBy && groupBy > 0 && data.length > groupBy) {
    const newData = data.slice(0, groupBy);

    const res = [...newData, {
      id: 'Others',
      label: 'Others',
      value: data.slice(groupBy).reduce((acc, item) => acc + item.value, 0),
    }];

    return res;
  }

  return data;
}

export function getGroupedBarChartData(data: BarChart['data'], groupBy: number) {
  if (groupBy && groupBy > 0 && data.length > groupBy) {
    const newData = data.slice(0, groupBy);

    const res = [...newData, {
      x: 'Others',
      y: data.slice(groupBy).reduce((acc, item) => acc + item.y, 0),
    }];

    return res;
  }

  return data;
}